import { createFileRoute } from "@tanstack/react-router";
import { HomeHero } from "../components/home-hero";
import { HomeTopForm } from "../components/home-top-form";
import { HomeServices } from "../components/home-services";
import { HomeHowItWorks } from "../components/home-how-it-works";
import { HomeTrustBadges } from "../components/home-trust-badges";
import { HomeGallery } from "../components/home-gallery";
import { HomeInAction } from "../components/home-in-action";
import { WaterJetDivider } from "../components/water-jet-divider";
import { HomeWhy } from "../components/home-why";
import { HomeReviews } from "../components/home-reviews";
import { HomeServiceArea } from "../components/home-service-area";
import { HomeFinalCta } from "../components/home-final-cta";
import { InlineQuoteSection } from "../components/inline-quote-section";
import { HomeFaq } from "../components/home-faq";
import { faqJsonLd } from "../data/faq";
import heroAvif480 from "../assets/hero-crew-surface-cleaner-480.avif";
import heroAvif640 from "../assets/hero-crew-surface-cleaner-640.avif";
import heroAvif825 from "../assets/hero-crew-surface-cleaner-825.avif";

const SITE = "https://capitalpropressurewashing.com";
const HOME_TITLE = "Pressure Washing & Soft Washing in Albany, NY | Capital Region";
const HOME_DESC =
  "Pressure washing in Albany, NY and the Capital Region. House, roof, concrete, deck and gutter cleaning by an insured veteran-owned team. Get a free quote!";
const HOME_OG_IMAGE = `${SITE}/__l5e/assets-v1/7fb348af-f23e-48db-88cd-6aeda94adc1a/hero-crew-surface-cleaner.jpg`;

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: HOME_TITLE },
      { name: "description", content: HOME_DESC },
      { property: "og:title", content: HOME_TITLE },
      { property: "og:description", content: HOME_DESC },
      { property: "og:url", content: `${SITE}/` },
      { property: "og:image", content: HOME_OG_IMAGE },
      { name: "twitter:title", content: HOME_TITLE },
      { name: "twitter:description", content: HOME_DESC },
      { name: "twitter:image", content: HOME_OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: `${SITE}/` },
      {
        rel: "preload",
        as: "image",
        type: "image/avif",
        href: heroAvif825,
        imagesrcset: `${heroAvif480} 480w, ${heroAvif640} 640w, ${heroAvif825} 825w`,
        imagesizes: "(max-width: 700px) 62vw, 100vw",
        fetchpriority: "high",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(faqJsonLd),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <main className="home-main">
      <HomeHero />
      <HomeTopForm />
      <HomeHowItWorks />
      <HomeServices />
      <HomeInAction />
      <HomeReviews />
      <HomeGallery />
      <WaterJetDivider />
      <HomeWhy />
      <HomeTrustBadges />
      <HomeServiceArea />
      <HomeFaq />
      <HomeFinalCta />
      <InlineQuoteSection />
    </main>
  );
}
